<template>
  <div class="pb-3">
    <div class="px-7 max-w-xl mx-auto">
      <button
        expand="block"
        color="secondary"
        class="button-purple mb-6"
        @click="nextStep"
      >
        <span class="font-bold text-[14px] capitalize block text-white"
          >Back to Home</span
        >
      </button>
    </div>
  </div>
</template>
<script setup>
import router from "@/router";
const nextStep = () => {
  router.push({ name: "Home" });
};
</script>
